import { render, staticRenderFns } from "./VueRepeaterLocal.vue?vue&type=template&id=518e54f0&"
import script from "./VueRepeaterLocal.vue?vue&type=script&lang=js&"
export * from "./VueRepeaterLocal.vue?vue&type=script&lang=js&"
import style0 from "./VueRepeaterLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports